import _ from "lodash";
import React from "react";
import { Link } from 'wouter';
import { useFeatures, useDataEnv } from '@/functions/DataEnv.js';

export default function Main({ pods, podule }) {
    const dataEnv = useDataEnv();
    const mainContent = _.get(dataEnv, 'main_content');
    const features = useFeatures();
    const miracleFundamentalsPod = features.find((pod) => pod.identity === 'mf-miracle-fundamentals');

    return (
        <>
            <div dangerouslySetInnerHTML={{__html: mainContent}}></div>

            <div className="site-row">
                <hr/>
            </div>

            <div className="pair-row site-row m-0">
                <div className="pair pair-first flex-3">
                    <h2>Miracle Fundamentals</h2>
                    <p className="mb-4">Miracle Fundamentals is the training program at Miracl.ing.
                        It introduces the underlying ideas, patterns, and disciplines that inform miracle work as
                        an intentional practice. The program is designed to be engaged over time, with material unfolding
                        in a way that allows understanding to mature through reflection, practice, and repetition.
                        It serves as a shared foundation, supporting further study, skill development, and continued
                        exploration within the Miracle Network.</p>
                    <Link to={`/${miracleFundamentalsPod.identity}`} className="site-btn">Begin Miracle Fundamentals</Link>
                </div>
                <div className="pair pair-second flex-1">
                    <img
                        src="https://aa-east2-images.s3.us-east-2.amazonaws.com/miracling-star.png"
                        alt="Mircle Fundamentals"
                        className="pair-row-image"
                    />
                </div>
            </div>
        </>
    );
}